import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import './index.css';
import {
  WorkExpCard,
  WorkExpTitle,
  WorkExpDescription,
  WorkExpButton,
  WorkExpTimeContainer,
  WorkExpEstTime,
  WorkExpTestModal
} from './components';
import { pushLog2DV2LogServer } from '../../../../services/logging';
import getEnv from '../../../../../services/util/getEnv';

const WorkExperienceTestContainer = (props) => {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }

  const [loading, setLoading] = useState(false);
  const [challenge_id] = useState(getEnv("REACT_APP_WORK_EXP_MCQ") || null);
  const [btnState, setBtnText] = useState(null);
  const [disabledStart, setDisabled] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [testModalVisible, setTestModalVisible] = useState(false);

  const initialize = () => {
    setLoading(props.loading);
    setBtnText(props.btnText);
  };

  const onTestModalClose = () => {
    setTestModalVisible(false);
  };

  useEffect(() => {
    initialize();
  }, [props.btnText, props.loading]);

  useEffect(() => {
    const modalDisplayed = localStorage.getItem('modalDisplayed');
    if (props.gb_seniority_improvement_conversion === 'sic_redirect_and_popup' && modalDisplayed && modalDisplayed === 'false') {
      localStorage.setItem('modalDisplayed', true);
      setTestModalVisible(true);
    } else {
      setTestModalVisible(false);
    }
  }, [props.gb_seniority_improvement_conversion]);

  const onStart = (e) => {
    e.preventDefault();
    setDisabled(true);
    setBtnLoading(true);

    if (props.btnText === 'Start now') {
      // [LOGGING] START_SENIORITY_ASSESSMENT
      pushLog2DV2LogServer.info('SEGMENTIO', 'START_SENIORITY_ASSESSMENT', {}, {}, null);
    } else {
      // [LOGGING] CONTINUE_SENIORITY_ASSESSMENT
      pushLog2DV2LogServer.info('SEGMENTIO', 'CONTINUE_SENIORITY_ASSESSMENT', {}, {}, null);
    }
    props.start(challenge_id);
  };

  return (
    <div style={props.style}>
      <WorkExpCard loading={loading}>
        <div className="new-mcq-description-wrapper-div">
          <WorkExpTitle gb_seniority_improvement_conversion={props.gb_seniority_improvement_conversion} />
          <WorkExpDescription gb_seniority_improvement_conversion={props.gb_seniority_improvement_conversion} />
          {props.gb_seniority_improvement_conversion === 'sic_banner_change' || (<WorkExpButton state={btnState} onButtonClicked={onStart} loading={btnLoading} disabled={props.impersonate || disabledStart} />)}
        </div>
        <WorkExpTimeContainer gb_seniority_improvement_conversion={props.gb_seniority_improvement_conversion}>
          <WorkExpEstTime gb_seniority_improvement_conversion={props.gb_seniority_improvement_conversion} btnState={btnState} onButtonClicked={onStart} />
        </WorkExpTimeContainer>
      </WorkExpCard>
      <WorkExpTestModal visible={testModalVisible} onStart={onStart} onModalClose={onTestModalClose} />
    </div>
  );
};

WorkExperienceTestContainer.propTypes = {
  impersonate: PropTypes.bool,
  seniority: PropTypes.string,
  loading: PropTypes.bool,
  btnText: PropTypes.string,
  start: PropTypes.func,
  style: PropTypes.object,
  gb_seniority_improvement_conversion: PropTypes.string
};

const mapStateToProps = appState => ({
  impersonate: appState.userObject.user ? appState.userObject.user.impersonate : false
});

export default connect(mapStateToProps, null)(WorkExperienceTestContainer);
